"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gromo": {
    "49f071b3": [{
      "hkey": "10c76587",
      "slug": "boario-spiazzi",
      "name": "Boario-Spiazzi",
      "primary": true,
      "skipSearch": false
    }],
    "boario": [{
      "hkey": "10c76587",
      "slug": "boario-spiazzi",
      "name": "Boario-Spiazzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4dd16c69": [{
      "hkey": "773a2350",
      "slug": "gromo",
      "name": "Gromo",
      "primary": true,
      "skipSearch": false
    }],
    "ripa": [{
      "hkey": "773a2350",
      "slug": "gromo",
      "name": "Gromo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;